import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "27",
  fill: "none",
  viewBox: "0 0 25 27"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<g stroke=\"#000\" stroke-miterlimit=\"10\" clip-path=\"url(#free-advice-mobile_svg__a)\"><path d=\"M13.132 4c2.245.128 4.49 1.024 6.208 2.817s2.51 3.97 2.377 6.275M13 6.945c1.585 0 3.038.64 4.226 1.793 1.057 1.152 1.585 2.689 1.585 4.225\"></path><path stroke-linejoin=\"round\" d=\"M4.774 3.896C3.849 4.921 2.66 6.713 2.66 9.146c0 2.817 1.453 5.763 4.755 9.092s6.076 4.866 8.717 4.866c2.377 0 4.094-1.28 5.019-2.177.396-.384.396-.896 0-1.28l-3.302-3.458c-.396-.384-.924-.384-1.32 0-.397.512-.793.896-1.057.896-.66.128-1.189 0-3.963-2.945s-3.037-3.457-2.905-4.097c0-.384.396-.64.924-1.153.397-.384.397-.896 0-1.28L6.094 3.896c-.396-.384-.924-.384-1.32 0Z\"></path></g><defs><clipPath id=\"free-advice-mobile_svg__a\"><path fill=\"#fff\" d=\"M2 3h21v21H2z\"></path></clipPath></defs>", 2)
  ])))
}
export default { render: render }